import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'components/Button';
import { getCompanyRegisterUrl } from '../../utils/helper';

// <editor-fold desc="CompanyIntro type definitions ...">

export type CompanyIntroProps = {
  title?: string;
  description?: string;
  sectorId: number;
};
// </editor-fold>

// <editor-fold desc="CompanyIntro component definition ...">
const CompanyIntro = ({
  title = '',
  description = '',
  sectorId,
}: CompanyIntroProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        <Col xs={12} className="p-4">
          <h2 className="text-primary">{title}</h2>
          <p>{description}</p>
          <Row>
            <Col xs="auto" style={{ marginTop: 15 }}>
              <Button href={getCompanyRegisterUrl(sectorId)} target="_blank">
                {t('Luo yritysprofiili')}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
// </editor-fold>

export default CompanyIntro;
